import { render, staticRenderFns } from "./updatePasswordForm.vue?vue&type=template&id=a79a4992&scoped=true"
import script from "./updatePasswordForm.vue?vue&type=script&lang=js"
export * from "./updatePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./updatePasswordForm.vue?vue&type=style&index=0&id=a79a4992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79a4992",
  null
  
)

export default component.exports